import * as React from "react";
import { styled, alpha } from "@mui/material";

import { makeStyles } from "@mui/styles";
import Color from "color";

import { TableRow, TableHead, TableCell } from "@mui/material";

export const useStyles = makeStyles((theme) => ({
  paper: {
    backgroundColor: theme.palette.background.main,
    color: theme.palette.text.main,
    padding: theme.spacing(2),
    height: "100%",
    width: "100%",
  },

  cardContentsWrapper: {
    display: "flex",
    flexDirection: "column",

    "& *": {
      margin: theme.spacing(0.5),
    },
  },

  cardHeader: {
    color: theme.palette.text.main,
    fontWeight: "900",
  },

  cardText1: {
    color: theme.palette.text.secondary,
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },

  cardText2: {
    color: alpha(theme.palette.text.main, 0.7),
    display: "flex",
    justifyContent: "start",
    alignItems: "center",
  },

  cardTextArea: {
    display: "flex",
    flexDirection: "column",
    alignItems: "start",
  },

  dataTableList: {
    // width: "100%",
    width: theme.spacing(100),
    overflowY: "hidden",
    overflowX: "scroll",
    height: theme.spacing(55),
  },

  dataTableItem: {
    // display:"inline-block",
   height:theme.spacing(10),
    width: theme.spacing(100),
    transition: theme.transitions.duration.fancy,
    "&:hover": {
      backgroundColor: alpha(theme.palette.primary.main, 0.1),
      color: theme.palette.secondary.main,
    },
  },

  dataTableItemCol2: {
    color: theme.palette.primary.main,
    fontWeight:"700"
  },

 
  dataTableItemSecondaryText: {
    "&:hover": {
      color: theme.palette.text.main,
    },
  },

  dataGridAvatar: {
    backgroundColor: theme.palette.common.grey,
  },

  tinygraph: {
   margin: `${theme.spacing(2)} ${theme.spacing(2)}`

  },
}));

<TableHead>
  <TableRow>
    {/* {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))} */}
  </TableRow>
</TableHead>;
